<template>
  <div class="myapprove">
    <div class="area_box" @click="chooseArea(1)">
      <img class="area_pic" :src="img.china">
      <div class="area_titie">中国地区</div>
      <img class="arrow" :src="img.arrow">
    </div>
    <div class="area_box" @click="chooseArea(2)">
      <img class="area_pic" :src="img.foregin">
      <div class="area_titie">海外地区</div>
      <img class="arrow" :src="img.arrow">
    </div>
    <van-popup v-model="show">
      <img style="width: 100%;" :src="img.travel">
      <button class="knowBtn" @click="chooseChina()">我知道了</button>
    </van-popup>
  </div>
  
</template>
<script>
  import common from '../../../api/common';
  import { mapState } from 'vuex';
  import {Cell, CellGroup,Popup } from 'vant';
  export default {
    data () {
      return {
        show: false,
        img:{
          china: require('../../../assets/img/lexus/china.png'),
          foregin: require('../../../assets/img/lexus/foregin.png'),
          arrow: require('../../../assets/img/lexus/arrow.png'),
          travel: require('../../../assets/img/travel.png'),
        }
      }
    },
    computed: {
      ...mapState({
        user: state => state.param.user,
        source: state => state.param.source
      })
    },
    created () {
      this.$store.commit('param/show', false)
      this.$appService.getToken(v => {
        if(v.token) {
          this.$store.dispatch('param/setToken', v.token)
        } else {
          this.$appService.needLogin()
        }
      })
      this.weburl=process.env.VUE_APP_URL
      var params={
        event_code: '车主认证_选择地区',
        event_id: '',
        title: '',
        value: '',
        path: '/Lexus/My/CarApprove.vue',
        user_id: this.user ? this.user.id : 0,
        source: this.source
      }
      common.BurialPoint(params).then(res => {
        if(res.data.state==1){
        }
      })
      var apppar={
        title:this.$route.meta.title
      }
      this.$appService.changeTitle(apppar)
    },
    methods: {
      chooseArea(type){
        if(type==1){
          this.show = true;
        }else{
          var params={
            url:this.weburl+'/lexus/my/car_list?type=2&is_have_card=0&source='+this.source ,
            isReturn: true 
          }
          this.$appService.openWebView(params)
        }
      },
      chooseChina(){
        this.show = false;
        var params={
          url:this.weburl+'/lexus/my/car_list?type=1&is_have_card=1&source='+this.source ,
          isReturn: true 
        }
        this.$appService.openWebView(params)
      }
    },
    components: {
      [Cell.name]: Cell,
      [CellGroup.name]: CellGroup,
      [Popup.name]:Popup
    }
  }
</script>
<style lang="scss">
.myapprove{
  .area_box{
    display: flex;
    align-items: center;
    padding: 20px;
    border-bottom: 0.5px solid rgba(0,0,0,.1);
    .area_pic{
      width: 150px;
      height: 100px;
    }
    .area_titie{
      flex: 1;
      font-size:14px;
      text-align: center;
    }
    .arrow{
      width: 10px;
      height: 15px;
      float: right;
    }
  }
  .van-popup{
    width: 270px;
    height: 220px;
    padding: 15px;
    text-align: center;
  }
  .knowBtn{
    width: 100%;
    height: 45px;
    color: #fff;
    background: #605C6B;
    font-size: 14px;
    font-weight: 400;
    margin-top: 10px;
  }
}
</style>
